module.exports = __webpack_public_path__ + "static/img/user.9f469d0b.svg";